module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedBlack.52d9b69.eot";